const CLIPBOARD_TYPE = {
  EXERCISE: 'EXERCISE',
  CIRCUIT: 'CIRCUIT',
};

const CLIPBOARD_KEY = 'system2_workout_clipboard';

export { CLIPBOARD_TYPE, CLIPBOARD_KEY };
